var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _g4, _g5, _g6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 21.9011C11.8141 22.125 12.2968 22.1126 12.6957 21.8846C15.383 20.3488 20.0528 16.8135 21.8867 12.2211C24.5785 6.2418 18.2581 1.46875 13.8899 4.9017C13.4342 5.25981 12.8613 5.66965 12.467 6.0579C12.2887 6.23343 11.9746 6.25133 11.7895 6.08296C11.2712 5.61133 10.461 5.00633 9.94076 4.65433C6.21673 2.13479 -0.559225 5.45597 2.33116 12.5442C3.38998 15.7258 8.43561 20.2397 11.4129 21.9011Z",
    fill: "url(#paint0_radial_2136_65140)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 21.9011C11.8141 22.125 12.2968 22.1126 12.6957 21.8846C15.383 20.3488 20.0528 16.8135 21.8867 12.2211C24.5785 6.2418 18.2581 1.46875 13.8899 4.9017C13.4342 5.25981 12.8613 5.66965 12.467 6.0579C12.2887 6.23343 11.9746 6.25133 11.7895 6.08296C11.2712 5.61133 10.461 5.00633 9.94076 4.65433C6.21673 2.13479 -0.559225 5.45597 2.33116 12.5442C3.38998 15.7258 8.43561 20.2397 11.4129 21.9011Z",
    fill: "url(#paint1_radial_2136_65140)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 21.9011C11.8141 22.125 12.2968 22.1126 12.6957 21.8846C15.383 20.3488 20.0528 16.8135 21.8867 12.2211C24.5785 6.2418 18.2581 1.46875 13.8899 4.9017C13.4342 5.25981 12.8613 5.66965 12.467 6.0579C12.2887 6.23343 11.9746 6.25133 11.7895 6.08296C11.2712 5.61133 10.461 5.00633 9.94076 4.65433C6.21673 2.13479 -0.559225 5.45597 2.33116 12.5442C3.38998 15.7258 8.43561 20.2397 11.4129 21.9011Z",
    fill: "url(#paint2_radial_2136_65140)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 21.9011C11.8141 22.125 12.2968 22.1126 12.6957 21.8846C15.383 20.3488 20.0528 16.8135 21.8867 12.2211C24.5785 6.2418 18.2581 1.46875 13.8899 4.9017C13.4342 5.25981 12.8613 5.66965 12.467 6.0579C12.2887 6.23343 11.9746 6.25133 11.7895 6.08296C11.2712 5.61133 10.461 5.00633 9.94076 4.65433C6.21673 2.13479 -0.559225 5.45597 2.33116 12.5442C3.38998 15.7258 8.43561 20.2397 11.4129 21.9011Z",
    fill: "url(#paint3_radial_2136_65140)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 21.9011C11.8141 22.125 12.2968 22.1126 12.6957 21.8846C15.383 20.3488 20.0528 16.8135 21.8867 12.2211C24.5785 6.2418 18.2581 1.46875 13.8899 4.9017C13.4342 5.25981 12.8613 5.66965 12.467 6.0579C12.2887 6.23343 11.9746 6.25133 11.7895 6.08296C11.2712 5.61133 10.461 5.00633 9.94076 4.65433C6.21673 2.13479 -0.559225 5.45597 2.33116 12.5442C3.38998 15.7258 8.43561 20.2397 11.4129 21.9011Z",
    fill: "url(#paint4_linear_2136_65140)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 21.9011C11.8141 22.125 12.2968 22.1126 12.6957 21.8846C15.383 20.3488 20.0528 16.8135 21.8867 12.2211C24.5785 6.2418 18.2581 1.46875 13.8899 4.9017C13.4342 5.25981 12.8613 5.66965 12.467 6.0579C12.2887 6.23343 11.9746 6.25133 11.7895 6.08296C11.2712 5.61133 10.461 5.00633 9.94076 4.65433C6.21673 2.13479 -0.559225 5.45597 2.33116 12.5442C3.38998 15.7258 8.43561 20.2397 11.4129 21.9011Z",
    fill: "url(#paint5_linear_2136_65140)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4129 21.9011C11.8141 22.125 12.2968 22.1126 12.6957 21.8846C15.383 20.3488 20.0528 16.8135 21.8867 12.2211C24.5785 6.2418 18.2581 1.46875 13.8899 4.9017C13.4342 5.25981 12.8613 5.66965 12.467 6.0579C12.2887 6.23343 11.9746 6.25133 11.7895 6.08296C11.2712 5.61133 10.461 5.00633 9.94076 4.65433C6.21673 2.13479 -0.559225 5.45597 2.33116 12.5442C3.38998 15.7258 8.43561 20.2397 11.4129 21.9011Z",
    fill: "url(#paint6_radial_2136_65140)",
    fillOpacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2136_65140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9312 8.05038V12.3935C11.9312 13.2983 13.0256 13.724 13.5575 12.9919C14.6729 11.4565 15.4231 9.6917 14.3623 8.2234C13.9408 7.63992 13.1591 7.25213 12.4819 7.30649C12.1247 7.33517 11.9312 7.692 11.9312 8.05038Z",
    fill: "#FA1C56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2136_65140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.4973,
    cy: 8.5328,
    rx: 3.34629,
    ry: 2.77509,
    transform: "rotate(-44.1902 18.4973 8.5328)",
    fill: "url(#paint7_radial_2136_65140)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_2136_65140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.5951,
    cy: 4.55008,
    rx: 1.26941,
    ry: 0.266727,
    transform: "rotate(7.16522 17.5951 4.55008)",
    fill: "#FF7383"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2136_65140)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.04182,
    cy: 4.54007,
    rx: 1.13899,
    ry: 0.18706,
    transform: "rotate(-0.697201 7.04182 4.54007)",
    fill: "#FF93BA",
    fillOpacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2136_65140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1337 7.4714L11.3681 15.1589C6.21189 10.1433 5.22039 6.6211 7.19623 5.83078C9.07127 5.08078 10.5713 6.29953 11.1337 7.4714Z",
    fill: "url(#paint8_radial_2136_65140)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2136_65140)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7588 7.02144C10.1288 6.93144 9.93379 6.40894 9.91504 6.15894C10.275 6.53394 10.6275 6.56519 10.7588 6.53394V7.02144Z",
    fill: "#FF7383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2136_65140",
    x: 9.93115,
    y: 5.30142,
    width: 6.94189,
    height: 10.0628,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2136_65140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2136_65140",
    x: 13.9153,
    y: 3.96681,
    width: 9.16406,
    height: 9.13199,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_2136_65140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2136_65140",
    x: 14.3352,
    y: 2.24164,
    width: 6.51978,
    height: 4.61688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2136_65140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2136_65140",
    x: 4.40283,
    y: 2.85251,
    width: 5.27783,
    height: 3.37512,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_2136_65140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2136_65140",
    x: 3.24976,
    y: 2.60001,
    width: 11.1184,
    height: 15.5589,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_2136_65140"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2136_65140",
    x: 8.91504,
    y: 5.15894,
    width: 2.84375,
    height: 2.8625,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_2136_65140"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2136_65140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.9122 4.22522) rotate(90) scale(17.2384 18.3016)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527969,
    stopColor: "#FF3B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F724B3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2136_65140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2687 8.52229) rotate(134.402) scale(15.9485 29.8731)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.797874,
    stopColor: "#C82092",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908039,
    stopColor: "#C82092"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2136_65140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9977 13.3414) rotate(-158.663) scale(17.0618 24.1192)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40984,
    stopColor: "#B91D43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833898,
    stopColor: "#B91D43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2136_65140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6702 10.3616) rotate(90) scale(14.8494)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671096,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2136_65140",
    x1: 13.3091,
    y1: 12.0998,
    x2: 19.3184,
    y2: 19.2514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694491,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2136_65140",
    x1: 12.5641,
    y1: 12.3978,
    x2: 5.51193,
    y2: 20.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694491,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2136_65140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.7604 9.67179) rotate(164.618) scale(12.911 13.6351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#FF73A6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93BA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2136_65140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8399 8.43879) rotate(172.927) scale(5.46853 7.27172)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7383",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2136_65140",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.2588 10.3795) rotate(-135.591) scale(9.51458 16.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6274",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.b0fea74d.svg";
export { ForwardRef as ReactComponent };